import PropTypes from 'prop-types'

import './funeralHomeHeading.scss'

const FuneralHomeHeading = ({
  clientName,
  downgradeLink = null,
  funeralHomeName = '',
  isLimitedClient,
  isQuarterback
}) => {
  const getMembershipLabel = () => {
    if (isLimitedClient)
      return 'Everplans Free'

    return 'Premium Lifetime'
  }

  const membershipLabel = getMembershipLabel()

  return (
    <span
      className='funeral-home-heading row-wrapper-sb'
      data-testid='funeral-home-heading'>
      <div className='client-name-section'>
        <h1>{clientName}</h1>
        {isQuarterback && (
          <div className='membership-and-funeral-home'>
            <div className='membership-container'>
              <div
                className={
                  `membership-label ${isLimitedClient ? 'free' : 'premium'}`
                }>
                {membershipLabel}
              </div>
              {downgradeLink}
            </div>
            <div className='funeral-home-info'>
              <strong>Funeral Home:</strong> {funeralHomeName}
            </div>
          </div>
        )}
      </div>
    </span>
  )
}

FuneralHomeHeading.propTypes = {
  clientName: PropTypes.string.isRequired,
  downgradeLink: PropTypes.node,
  funeralHomeName: PropTypes.string,
  isLimitedClient: PropTypes.bool,
  isQuarterback: PropTypes.bool
}

export default FuneralHomeHeading
